module.exports = __webpack_public_path__ + "img/preset5.5e82c559.png";